import { t } from "@lingui/macro";
import type { DownloadStatusDto } from "@reactive-resume/dto";
import { axios } from "@/client/libs/axios";

const FAST_POLL_INTERVAL_MS = 1_000; // poll rapide au début (PDF souvent prêt en quelques secondes)
const FAST_POLL_ATTEMPTS = 10;
const POLL_INTERVAL_MS = 3_000; // puis espacement normal
const MAX_ATTEMPTS = 90;

const wait = (milliseconds: number) => new Promise((resolve) => setTimeout(resolve, milliseconds));

export async function pollDownload(downloadId: string): Promise<{ url: string }> {
  for (let attempt = 0; attempt < MAX_ATTEMPTS; attempt += 1) {
    const response = await axios.get<DownloadStatusDto>(`/downloads/${downloadId}`);

    if (response.data.status && response.data.url) return { url: response.data.url };
    if (response.data.error === "RESUME_LAYOUT_OVERFLOW") {
      throw new Error(
        t`Le contenu dépasse les limites d’une page. Ajustez la mise en page du CV avant de réessayer.`,
      );
    }
    if (response.data.error) {
      throw new Error(t`La génération du PDF a échoué. Veuillez réessayer.`);
    }

    // Rythme adaptatif : 10 premières vérifications à 1 s (ressenti rapide),
    // puis 3 s pour ne pas marteler l'API pendant les longues générations.
    const interval = attempt < FAST_POLL_ATTEMPTS ? FAST_POLL_INTERVAL_MS : POLL_INTERVAL_MS;
    await wait(interval);
  }

  throw new Error(t`La génération du PDF (.pdf) n'a pas terminé dans le délai attendu.`);
}
